import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DialogService, SelectOption } from '@bcl/design-system';
import { ConsumablesDialogComponent } from 'src/app/pages/area-monitor/components/consumables-dialog/consumables-dialog.component';
import { MonitorProduct } from 'src/app/pages/area/area.model';
import { environment } from 'src/environments';
import { VisitConsumablesDialogComponent } from '../visit-consumables-dialog/visit-consumables-dialog.component';
import { Observable } from 'rxjs';

export type AddProductDialogData = {
  warehouses: SelectOption[];
  products: SelectOption[];
  units: SelectOption[];
  product?: MonitorProduct;
  operationType: string;
  defaultCar?: number;
};

export type AddProductResult = {
  productId: string;
  amount: number;
  unitId: string;
  initialDate: Date;
  warehouseId: string;
  supplierId: string;
  action: string;
  visitProductId: number;
  allowToDisappear: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class AddProductService {
  constructor(private dialog: DialogService, private http: HttpClient) {}

  public open(
    settings: MatDialogConfig<AddProductDialogData>
  ): MatDialogRef<
    VisitConsumablesDialogComponent,
    AddProductResult | undefined
  > {
    return this.dialog.open(VisitConsumablesDialogComponent, {
      minWidth: '90vw',
      ...settings,
    });
  }

  public getProductsForWarehouse(warehouseId: number): any {
    const url = environment.apiHost + '/stock/list';
    return this.http.get(url, {
      params: {
        warehouseId: warehouseId.toString(),
        inStock: true,
        active: true,
        pageNumber: 1,
        pageSize: 100000,
      },
    });
  }

  public getSuppliersForProduct(productId: number): any {
    const url = environment.apiHost + '/stock/products/details/suppliers';
    return this.http.get(url, {
      params: {
        productId: productId.toString(),
        pageNumber: 1,
        pageSize: 10000,
      },
    });
  }

  public addVisitProduct(details: any): any {
    const url = `${environment.apiHost}/v2/visits/product`;
    const body = details;

    return this.http.post(url, body);
  }
  public editVisitProduct(details: any): any {
    const url = `${environment.apiHost}/v2/visits/product`;
    const body = details;

    return this.http.patch(url, body);
  }
  public deleteVisitProduct(visitProductId: number): any {
    const url = `${environment.apiHost}/v2/visits/product/${visitProductId}`;

    return this.http.delete(url);
  }
  public getProductsForVisit(visitId: string): Observable<MonitorProduct[]> {
    const url = `${environment.apiHost}/v2/visits/products`;

    return this.http.get<MonitorProduct[]>(url, {
      params: {
        visitId,
      },
    });
  }
}
